/** Phase E — list of payer-scoped runs; click a row to open it. */
import React from 'react';
import { StatusPill, money } from '../finance/financeUi';

export function RunsTable({ runs, selected, onSelect }) {
  if (!runs.length) return <p className="px-5 py-6 text-sm text-muted-foreground" data-testid="runs-empty">No payer Payout Runs for this period yet.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[720px] text-sm" data-testid="runs-table">
        <thead className="text-left text-xs uppercase tracking-wide text-muted-foreground">
          <tr><th className="px-5 py-2">Payer</th><th>Type</th><th className="text-right">Gross</th><th className="text-right">Owes downline</th><th className="text-right">Retained</th><th className="px-5">Status</th></tr>
        </thead>
        <tbody className="divide-y">
          {runs.map((r) => (
            <tr key={r.run_id} onClick={() => onSelect(r.run_id)} data-testid={`run-row-${r.run_id}`}
                className={`cursor-pointer transition-colors hover:bg-muted/50 ${selected === r.run_id ? 'bg-muted/60' : ''}`}>
              <td className="px-5 py-2.5 font-medium">{r.payer_name}<span className="block text-xs font-normal text-muted-foreground">{r.period}</span></td>
              <td>{r.payer_kind.replace('_', ' ')}</td>
              <td className="text-right tabular-nums">{money(r.gross_entitlement)}</td>
              <td className="text-right tabular-nums font-semibold" data-testid={`run-row-downline-${r.run_id}`}>{money(r.downline_obligations)}</td>
              <td className="text-right tabular-nums">{money(r.retained_economics)}</td>
              <td className="px-5"><StatusPill value={r.status} testid={`run-row-status-${r.run_id}`} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
